import React from 'react';
import styled from 'styled-components';
import images from '../../Theming/images';

const Logo = styled.img`
  width: 280px;
  height: 280px;
  margin-top: 20px;
`;
const step = [
  images.android_guide_1,
  images.android_guide_2,
  images.android_guide_3,
];

interface guidStepInterface {
  guidStep: number;
}

const AndroidGuideImages: React.FC<guidStepInterface> = ({ guidStep }) => {
  return <Logo src={step[guidStep]} alt="Guide Logo" />;
};

export default AndroidGuideImages;
